<template>
  <header class="mobile-top-nav">
    <button
      class="mobile-top-nav__back"
      type="button"
      aria-label="返回"
      @click="goBack"
    >
      <i class="el-icon-arrow-left"></i>
    </button>
    <h1 class="mobile-top-nav__title">{{ title }}</h1>
    <div class="mobile-top-nav__side">
      <slot name="right"></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileTopNav',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }

      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style scoped>
.mobile-top-nav {
  display: none;
}

@media (max-width: 768px) {
  .mobile-top-nav {
    position: sticky;
    top: 0;
    z-index: 20;
    display: grid;
    grid-template-columns: 48px minmax(0, 1fr) 48px;
    align-items: center;
    min-height: 48px;
    padding-top: env(safe-area-inset-top);
    background: rgba(255, 255, 255, 0.98);
    border-bottom: 1px solid #edf0f4;
    box-shadow: 0 6px 18px rgba(31, 41, 55, 0.06);
  }

  .mobile-top-nav__back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: none;
    background: transparent;
    color: #1f2937;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
  }

  .mobile-top-nav__title {
    overflow: hidden;
    color: #1f2937;
    font-size: 17px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-top-nav__side {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }
}
</style>
